export default __webpack_public_path__ + "static/media/tech_scale1.53826527.png";